import Vue from 'vue';
import * as utils from '../utils';

export default {
  name: 'Emails',
  props: ['propEmail'],
  data: function () {
    return {
      email: {},
      message: '',
    }
  },
  computed: {
    emailValue: function () { return this.email.email; },
    emailDescr: function () {
      return this.email.descr && this.email.descr != '' ? this.email.descr : 'Email';
    },
  },
  watch: {
    emailValue: function (value) {
      this.message = this.validateEmail(value);
    },
  },
  methods: {
    validateEmail(value) {
      if (utils.validateEmail(value)) {
        this.email.valid = true;
        return '';
      }
      else {
        this.email.valid = false;
        return this.$t('login.validEmail');
      }
    },
  },
  created() {
    this.email = this.propEmail;
  }
}